if (window.jQuery) {
    window.jQuery(function () {
        if (!window.WP) return;
        var body = WP.body;

        if (body.dataset.openSubscribe === '1') {
            var t = document.querySelector('.js-trigger-subscription')
                 || document.querySelector('[data-modal-trigger="subscriptionModal"]');
            if (t) { t.click(); }
        }

        
        if (body.dataset.openSuccess === '1') {
            var ts = document.querySelector('.js-trigger-success');
            if (ts) { ts.click(); }
            if (window.history && window.history.replaceState) {
                var url = new URL(window.location.href);
                url.searchParams.delete('subscribed');
                var clean = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
                window.history.replaceState({}, '', clean);
            }
        }

        // DON-652: a writer értesítő e-mail akció-gombjai (?eact=like|comment|share|subscribe).
        // A szerver whitelisteli és body data-attribútumként adja át.
        var action = body.dataset.emailAction || '';
        if (action) {
            if (action === 'like') {
                // Az első action-item a szív: belépett usernél .js-add-heart (AJAX lájk),
                // vendégnél data-modal-trigger="loginModal" — a click mindkettőt jól kezeli.
                // Már lájkolt cikknél nem kattintunk, különben visszavonná a lájkot.
                var heart = document.querySelector('.readpost-postaction .readpost-action-item');
                if (heart && !heart.classList.contains('active-heart')) { heart.click(); }
            } else if (action === 'comment') {
                // Görgetés a hozzászólás-szekcióhoz (a .js-write-comment viselkedése,
                // de vendégnél is görgetünk, nem login-modalt nyitunk).
                // A mérést/korrekciót a WP.scrollToComments() végzi — zárolt cikknél
                // (nincs hozzászólás-panel) false-szal tér vissza, és nem történik semmi.
                WP.scrollToComments();
            } else if (action === 'share') {
                var tsh = document.querySelector('.js-trigger-share');
                if (tsh) { tsh.click(); }
            } else if (action === 'subscribe') {
                // Tier-zárolt cikknél a cikket feloldó csomagok modalja, egyébként a
                // globális előfizetés-modal.
                var tsub = document.querySelector('[data-modal-trigger="subscriptionTierModal"]')
                        || document.querySelector('.js-trigger-subscription')
                        || document.querySelector('[data-modal-trigger="subscriptionModal"]');
                if (tsub) { tsub.click(); }
            }
            if (window.history && window.history.replaceState) {
                var url2 = new URL(window.location.href);
                url2.searchParams.delete('eact');
                var clean2 = url2.pathname + (url2.searchParams.toString() ? '?' + url2.searchParams.toString() : '') + url2.hash;
                window.history.replaceState({}, '', clean2);
            }
        }
    });
}

